import { useState } from 'react';
import { Button } from '../../components/ui';

export interface RecoveryCodesProps {
  readonly codes: readonly string[];
  onDone(): void;
}

/** The recovery codes, shown once after the app is connected (W20). */
export function RecoveryCodes({ codes, onDone }: RecoveryCodesProps) {
  const [isCopied, setIsCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(codes.join('\n'));
    setIsCopied(true);
  };
  return (
    <div className="flex flex-col gap-3">
      <p className="text-fg-2">
        Сохраните резервные коды в надёжном месте. Каждый код заменяет код из приложения один раз — если телефон потерян или недоступен. Больше они не
        покажутся.
      </p>
      <ol aria-label="Резервные коды" className="grid grid-cols-2 gap-x-4 gap-y-1 rounded-2 border border-border-1 bg-bg-2 px-4 py-3 text-[14px] font-medium tabular-nums tracking-wider">
        {codes.map((code) => (
          <li key={code}>{code}</li>
        ))}
      </ol>
      <div className="flex gap-2">
        <Button type="button" variant="secondary" onClick={() => void copy()}>
          {isCopied ? 'Скопировано' : 'Скопировать'}
        </Button>
        <Button type="button" onClick={onDone}>
          Я сохранил коды — продолжить
        </Button>
      </div>
    </div>
  );
}
